module.exports = __webpack_public_path__ + "img/9788991095892.a2d4b8cc.jpg";